import { ReactNode, CSSProperties } from 'react';
import { Rnd } from 'react-rnd';
import { useTheme } from '@mui/material';

interface ChatGPTWindowProps {
  children: ReactNode;
  windowContainerStyle?: CSSProperties; // Optional style prop
  default?: Partial<{
    x: number;
    y: number;
    width: number;
    height: number;
  }>; // Optional default prop with correct typing
}

const ChatGPTWindow = ({ children, windowContainerStyle, default: defaultPosition }: ChatGPTWindowProps) => {
  const theme = useTheme();
  const isMobile = window.innerWidth <= 600;

  const styles = {
    windowContainer: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: isMobile ? '0' : '12px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
      zIndex: 1300, // Above AppBar (1100) and Modal backdrop (1200)
      position: 'fixed' as const,
      overflow: 'hidden',
    },
  };

  // Mobile: Full screen, Desktop: Draggable window
  const defaultWidth = isMobile ? window.innerWidth : defaultPosition?.width || 500;
  const defaultHeight = isMobile ? window.innerHeight : defaultPosition?.height || 500;
  const defaultX = isMobile ? 0 : defaultPosition?.x || window.innerWidth - 600;
  const defaultY = isMobile ? 0 : defaultPosition?.y || window.innerHeight - 600;

  return (
    <Rnd
      default={{
        x: defaultX,
        y: defaultY,
        width: defaultWidth,
        height: defaultHeight,
      }}
      minWidth={isMobile ? window.innerWidth : 300}
      minHeight={isMobile ? window.innerHeight : 300}
      maxWidth={isMobile ? window.innerWidth : undefined}
      maxHeight={isMobile ? window.innerHeight : undefined}
      disableDragging={isMobile}
      enableResizing={!isMobile}
      bounds="window"
      dragHandleClassName="draggable-handle"
      style={{
        ...styles.windowContainer,
        ...windowContainerStyle,
      }} // Merge default and custom styles
    >
      {children}
    </Rnd>
  );
};

export default ChatGPTWindow;
